module.exports = __webpack_public_path__ + "img/connerhall-v-474x632.b800aecc.jpg";